import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setAuthToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [workspace, setWorkspace] = useState(null);
  const [demo, setDemo] = useState(false);
  const [status, setStatus] = useState("checking"); // checking | authed | anon

  const apply = useCallback((data) => {
    if (data?.token) setAuthToken(data.token);
    setUser(data.user);
    setWorkspace(data.workspace);
    setDemo(!!data.demo);
    setStatus("authed");
  }, []);

  useEffect(() => {
    api
      .get("/auth/me")
      .then((r) => apply(r.data))
      .catch(() => {
        setAuthToken(null);
        setStatus("anon");
      });
  }, [apply]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    apply(data);
    return data;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    apply(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } finally {
      setAuthToken(null);
      setUser(null);
      setWorkspace(null);
      setStatus("anon");
    }
  };

  const refreshWorkspace = (ws) => setWorkspace(ws);

  return (
    <AuthContext.Provider value={{ user, workspace, status, demo, login, register, logout, refreshWorkspace }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
